import { defineMessages } from 'react-intl';

/**
 * Shared copy for the session-urgency surfaces (header chip, row flag, and the
 * session-list filter). Centralised so the same wording + ids are reused across
 * every surface instead of being re-declared inline.
 */
export const sessionUrgencyMessages = defineMessages({
  urgent: {
    defaultMessage: 'Urgent',
    id: 'h54WzzCGb4',
    description: 'Label for a session that is marked urgent (chip, flag, filter)',
  },
  urgency: {
    defaultMessage: 'Urgency',
    id: 'yu28TA+yX5',
    description: 'Session-list urgency filter / column label',
  },
  markAsUrgent: {
    defaultMessage: 'Mark as urgent',
    id: 'BymiUdS/uG',
    description: 'Action that flags the current session as urgent',
  },
  removeUrgent: {
    defaultMessage: 'Remove urgent flag',
    id: 'hIutlg7+RN',
    description: 'Action that clears the urgent flag from the current session',
  },
  updateFailed: {
    defaultMessage: 'Failed to update urgency',
    id: 'o1GMBvZdNU',
    description: 'Error toast shown when changing a session’s urgency fails',
  },
});
